"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeObjError = exports.getTelcoHost = exports.getMethodNotAllowedReject = exports.makeUndefinedValueNull = exports.makeLoginRedirect = exports.normalizeRedirectError = exports.isRedirectToLoginError = exports.generalAdabyronBehaviour = exports.buildApiUrl = exports.USER_TYPES = exports.processNameOpen = exports.processNameTges = exports.processName = void 0;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
const bit_utils_front_sonda_1 = __importDefault(require("@gcloud-npm/bit.utils.front-sonda"));
const bit_utils_monitoring_1 = require("@gcloud-npm/bit.utils.monitoring");
const bit_utils_types_1 = require("@gcloud-npm/bit.utils.types");
const bit_utils_request_1 = __importStar(require("@gcloud-npm/bit.utils.request"));
const bit_utils_sonda_1 = __importDefault(require("@gcloud-npm/bit.utils.sonda"));
exports.processName = 'ADABYRON-API';
exports.processNameTges = "".concat(exports.processName, "-TGES");
exports.processNameOpen = "".concat(exports.processName, "-OPEN");
(function (USER_TYPES) {
    USER_TYPES["CLIENT"] = "Telco";
    USER_TYPES["TGES"] = "Gestor";
    USER_TYPES["OPEN"] = "";
})(exports.USER_TYPES || (exports.USER_TYPES = {}));
var buildApiUrl = function (endpoint, idRequest, queryParams, urlParamsToReplace) {
    var URL_API = "".concat(endpoint, "?").concat(idRequest);
    if (queryParams) {
        for (var _i = 0, queryParams_1 = queryParams; _i < queryParams_1.length; _i++) {
            var queryParam = queryParams_1[_i];
            var param = queryParam.param, value = queryParam.value;
            if (param) {
                if (!Object.prototype.hasOwnProperty.call(queryParam, 'value')) {
                    URL_API += "&".concat(param);
                }
                else if (value !== undefined) {
                    URL_API += "&".concat(param, "=").concat(String(value));
                }
            }
        }
    }
    if (urlParamsToReplace) {
        urlParamsToReplace.forEach(function (paramToReplace) {
            var param = paramToReplace.param, value = paramToReplace.value;
            URL_API = URL_API.replace(param, String(value));
        });
    }
    return URL_API;
};
exports.buildApiUrl = buildApiUrl;
/**
 * generalAdabyronBehaviour: Comportamiento predefinido para una promesa de Adabyron que se puede personalizar.
 * @param context Contexto necesario
 * @param idFront IDFront necesario
 * @param path  Path necesario
 * @param {array} userTypes Tipo de usuario que puede acceder al método
 * @param {string} eventName Nombre del evento
 * @param {array} queryParams (optional): Parámetros a añadir a la URL
 * @param {array} urlParamsToReplace (optional): Parámetros a reemplazar en la URL
 * @param {string} mockedInfo Mocked info
 * @param {MethodType} methodType Tipo de método en la request: GET, POST, PUT, HEAD
 * @param {object} requestObject (optional): Datos necesarios para la request => (PUT / POST)
 * @param {function} onErrorCallback (optional): Callback que se ejecuta cuando la petición ha sido rechazada.
 * @param {function} onSuccessCallback (optional): Callback que se ejecuta cuando la petición ha ido correctamente.
 * @param {function} maximizeRetrievedData (optional): Flag que incluye información adicional disponible en la respuesta.
 * @param {function} onSuccessNormalizer (optional): Función normalizadora para los datos cuando la petición ha ido correctamente.
 * @param {object} requestHeaders (optional): Headers extra necesarios
 * @returns {promise} Promesa de la request
 */
var generalAdabyronBehaviour = function (params) {
    var context = params.context, idFront = params.idFront, path = params.path, userTypes = params.userTypes, eventName = params.eventName, queryParams = params.queryParams, urlParamsToReplace = params.urlParamsToReplace, mockedInfo = params.mockedInfo, methodType = params.methodType, requestObject = params.requestObject, onErrorCallback = params.onErrorCallback, onSuccessCallback = params.onSuccessCallback, maximizeRetrievedData = params.maximizeRetrievedData, onSuccessNormalizer = params.onSuccessNormalizer, requestHeaders = params.requestHeaders, telcoHostVersion = params.telcoHostVersion;
    var idRequest = (0, bit_utils_monitoring_1.getUUID)(idFront);
    var name = context.environment.name;
    var _a = (0, exports.getTelcoHost)(context, path, userTypes, telcoHostVersion), endpoint = _a.endpoint, headers = _a.headers, processName = _a.processName, allowed = _a.allowed;
    if (!allowed) {
        return (0, exports.getMethodNotAllowedReject)(path);
    }
    var sonda = new bit_utils_sonda_1.default({
        eventName: "".concat(eventName).concat(telcoHostVersion ? '_V' + telcoHostVersion : ''),
        context: context,
        uniqueId: idRequest,
        origin: processName,
    });
    var URL_API = (0, exports.buildApiUrl)(endpoint, idRequest, queryParams, urlParamsToReplace);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)(mockedInfo, name);
    var onSuccessDefault = function (xhr) {
        var response = xhr.response, responseURL = xhr.responseURL;
        if ((0, exports.isRedirectToLoginError)(responseURL)) {
            (0, exports.makeLoginRedirect)(responseURL);
        }
        else {
            var datos = JSON.parse(response).datos;
            return onSuccessNormalizer ? onSuccessNormalizer(datos) : datos;
        }
    };
    var onSuccessMaximizeData = function (xhr) {
        var response = xhr.response, responseURL = xhr.responseURL;
        if ((0, exports.isRedirectToLoginError)(responseURL)) {
            (0, exports.makeLoginRedirect)(responseURL);
        }
        else {
            var _a = JSON.parse(response), datos = _a.datos, warnings = _a.warnings;
            var processedResponse = __assign(__assign({}, datos), { warnings: warnings });
            return onSuccessNormalizer
                ? onSuccessNormalizer(processedResponse)
                : processedResponse;
        }
    };
    try {
        var request = new bit_utils_request_1.default({
            method: methodType,
            data: (methodType === bit_utils_types_1.MethodType.POST || methodType === bit_utils_types_1.MethodType.PUT) &&
                requestObject &&
                requestObject,
            endpoint: URL_API,
            onError: onErrorCallback ||
                (function (response) { return (0, exports.normalizeObjError)(response, context); }),
            onSuccess: onSuccessCallback ||
                (maximizeRetrievedData
                    ? function (response) { return onSuccessMaximizeData(response); }
                    : function (response) { return onSuccessDefault(response); }),
            sonda: sonda,
            headers: requestHeaders ? __assign(__assign({}, headers), requestHeaders) : headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.generalAdabyronBehaviour = generalAdabyronBehaviour;
var isRedirectToLoginError = function (responseUrl) {
    if (responseUrl && responseUrl.indexOf('DesafioUnico') !== -1) {
        return true;
    }
    return false;
};
exports.isRedirectToLoginError = isRedirectToLoginError;
var normalizeRedirectError = function (responseUrl) {
    var urlActual = window.location.href;
    if (window.location.hostname === 'www.movistar.es') {
        // eslint-disable-next-line max-len
        return "https://www.movistar.es/mimovistar-cliente/publico/servicio/login?urlContenedora=".concat(responseUrl, "&urlDestino=").concat(encodeURIComponent(urlActual));
    }
    if (window.location.hostname === 'www.movistar.es.cert') {
        // eslint-disable-next-line max-len
        return "https://www.movistar.es.cert/mimovistar-cliente/publico/servicio/login?urlContenedora=".concat(responseUrl, "&urlDestino=").concat(encodeURIComponent(urlActual));
    }
    if (window.location.hostname === 'www.movistar.es.inte') {
        // eslint-disable-next-line max-len
        return "https://www.movistar.es.inte/mimovistar-cliente/publico/servicio/login?urlContenedora=".concat(responseUrl, "&urlDestino=").concat(encodeURIComponent(urlActual));
    }
    return '#';
};
exports.normalizeRedirectError = normalizeRedirectError;
var makeLoginRedirect = function (responseUrl) {
    window.location.href = (0, exports.normalizeRedirectError)(responseUrl);
};
exports.makeLoginRedirect = makeLoginRedirect;
var makeUndefinedValueNull = function (obj) {
    return (0, bit_utils_common_1.applyTransform2Object)([
        {
            type: 'undefined',
            method: function () { return null; },
        },
    ], function (key) { return key; }, obj);
};
exports.makeUndefinedValueNull = makeUndefinedValueNull;
var getMethodNotAllowedReject = function (path) {
    return Promise.reject({
        status: 418,
        statusText: "I'm a teapot",
        response: "Method not allowed for this type of user: ".concat(path),
    });
};
exports.getMethodNotAllowedReject = getMethodNotAllowedReject;
var getTelcoHost = function (context, path, userTypesAllowed, version) {
    try {
        var environment = context.environment, userType = context.userType;
        if (userTypesAllowed.includes(userType)) {
            var connectionData = environment.telco;
            var prefixToApply = '/cliente/api/';
            var finalProcessName = exports.processName;
            if (userType === exports.USER_TYPES.TGES) {
                (connectionData = environment.tges);
                prefixToApply = '';
                finalProcessName = exports.processNameTges;
            }
            if (userType === exports.USER_TYPES.OPEN) {
                prefixToApply = '/abierto/api/';
                finalProcessName = exports.processNameOpen;
            }
            var host = connectionData.endpoint, headers = connectionData.headers;
            var pathBegin = path.substr(0, path.indexOf('/'));
            var pathEnd = path.substr(path.indexOf('/') + 1, path.length);
            var finalEndpoint = "".concat(host).concat(prefixToApply).concat(pathBegin, "/");
            if (version) {
                finalEndpoint = "".concat(finalEndpoint, "v").concat(version, "/");
            }
            return {
                endpoint: "".concat(finalEndpoint).concat(pathEnd),
                headers: headers,
                processName: finalProcessName,
                allowed: true,
            };
        }
        else {
            return {
                endpoint: '',
                headers: {},
                processName: '',
                allowed: false,
            };
        }
    }
    catch (error) {
        console.error(error);
        var frontSonda = new bit_utils_front_sonda_1.default({
            processName: 'getTelcoHost',
            context: context,
            filePath: 'utils/ada-byron',
        });
        frontSonda.errorMessage({ info: "error on path ".concat(path), error: error });
    }
    return null;
};
exports.getTelcoHost = getTelcoHost;
var normalizeObjError = function (xhr, context) {
    var objError = {
        status: xhr.status,
        statusText: xhr.statusText,
        response: null,
    };
    if (objError.status === 401 || objError.status === 400) {
        var userType = context.userType;
        if (userType === exports.USER_TYPES.TGES) {
            window.location.href = "".concat(context.environment.tges.endpoint, "autorizacion/acceso");
        }
    }
    try {
        objError.response = JSON.parse(xhr.response);
    }
    catch (error) {
        objError.response = xhr.response;
    }
    return objError;
};
exports.normalizeObjError = normalizeObjError;
//# sourceMappingURL=index.js.map